<script setup lang="ts">
import { models } from 'cesg-shared';
import { useI18n } from 'vue-i18n';
import { RadioGroup } from '../radio-group';

withDefaults(
  defineProps<{
    name: string;
    modelValue: models.YesNo | null | undefined;
    disabled?: boolean;
    required?: boolean;
  }>(),
  {
    disabled: false,
    required: false,
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: models.YesNo];
}>();

const { t } = useI18n();
</script>

<template>
  <RadioGroup
    :name="name"
    :model-value="modelValue"
    :disabled="disabled"
    :required="required"
    :options="[
      { id: `${name}-true`, value: models.YesNo.Yes, label: t('yes') },
      { id: `${name}-false`, value: models.YesNo.No, label: t('no') },
    ]"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
